import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PricingCalculatorComponent } from './pricing-calculator.component';
import { PricingCalculatorRoutingModule } from './pricing-calculator-routing.module';

@NgModule({
  declarations: [
    PricingCalculatorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    PricingCalculatorRoutingModule
  ],
  exports: [
    PricingCalculatorComponent
  ]
})
export class PricingCalculatorModule { }